module.exports = __webpack_public_path__ + "static/media/Partner2.3b131d46.webp";